<script lang="ts">
  import Heading from "./atoms/Heading.svelte";
  import ProductPrices from "./organisms/ProductPrices.svelte";
  import { getDefaultProductOrder } from "../helpers/helperMethods";
  import type { AvaliableProducts, Offer, Product } from "../helpers/types";
  import type { ChooseAgreementFlow } from "./ChooseAgreement.svelte";

  interface Props {
    flow: ChooseAgreementFlow;
    onComplete: () => void;
    goBack: () => void;
    headerLevel?: 1 | 2;
    priceHeading?: string;
    productOrder?: string[];
    autoSelectSingle?: boolean;
  }

  let {
    flow,
    onComplete,
    goBack,
    headerLevel = 1,
    priceHeading = "Vilket elavtal passar dig?",
    productOrder = getDefaultProductOrder(),
    autoSelectSingle = false,
  }: Props = $props();

  let facilityInformation = $state({ ...flow.facilityInformation });

  let selectedProductId = $state(flow.selectedProductId ?? null);
  let selectedProduct: Product | undefined = $state();
  let selectedAddons = flow.additionalProducts ?? [];
  let showSelectProductError = $state(false);
  let offer: Offer | undefined = $state();
  let avaliableProducts: AvaliableProducts = $state({});

  const onPriceContinue = () => {
    if (!selectedProduct && autoSelectSingle) {
      const allProducts = [
        ...(avaliableProducts.fixedProducts ?? []),
        ...(avaliableProducts.variableProducts ?? []),
        ...(avaliableProducts.hourlyProducts ?? []),
      ];
      if (allProducts.length === 1) {
        selectedProduct = allProducts[0];
        selectedProductId = selectedProduct.id;
      }
    }

    if (!selectedProduct) {
      showSelectProductError = true;
      return;
    }

    if (offer && offer.extraField && offer.extraFieldTitle) {
      flow.setExtraFieldTitle?.(offer.extraFieldTitle);
    }

    flow.setProductId(selectedProduct.id);
    flow.setProductTypeId(selectedProduct.typeId);
    flow.setProductType(selectedProduct.type);
    flow.setStartDates(selectedProduct.startDates);
    flow.setZipCode((facilityInformation.zipcode ?? "").toString());

    if (selectedProductId !== undefined && selectedProductId !== selectedProduct.id) {
      const updatedAddons = selectedProduct.addons
        .filter((addon) => selectedAddons.includes(addon.id))
        .map((addon) => addon.id);
      flow.setAdditionalProducts?.(updatedAddons);
    }

    onComplete();
  };

  const removeSelectedProductId = () => {
    flow.setProductId(null);
  };
</script>

<ProductPrices
  bind:showSelectProductError
  bind:avaliableProducts
  purchaseFlowType={flow.purchaseFlowType}
  {productOrder}
  estimation={flow.estimation}
  bind:selectedProductId
  bind:selectedProduct
  bind:zipcode={facilityInformation.zipcode}
  campaign={flow.campaign}
  {removeSelectedProductId}
  {goBack}
  onClickContinue={(e) => {
    e.preventDefault();
    onPriceContinue();
  }}
  bind:offer
>
  <Heading level={headerLevel} class="text-Neutral900">{priceHeading}</Heading>
</ProductPrices>
